import { Provider } from 'react-redux';
import { store } from '../../../store/store';
import DictionaryGate from './DictionaryGate';
import LegacyLocalizeSync from './LegacyLocalizeSync';
import { LocalizationProvider } from './LocalizationContext';

const TranslatorProvider = ({ children }) => (
  <Provider store={store}>
    <LocalizationProvider>
      <LegacyLocalizeSync />
      <DictionaryGate>{children}</DictionaryGate>
    </LocalizationProvider>
  </Provider>
);

export default TranslatorProvider;
